import { useEffect } from 'react';
import history from '../../utils/history';
export default function ScrollToTopOnMount() {
  const { pathname } = history.location;
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
